module.exports = __webpack_public_path__ + "media/data-center-graphic.bffd55edcdd87d611eb56275afbf471d.svg";